export default {
  reload: 'Reload',
  experiencingDifficulty: 'We are currently experiencing some difficulties!',
  underMaintenance: 'We are currently updating our services. Please check back soon!',
};
